import {
  HttpClient,
  HttpEventType,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import { IMarketLinkageInitiativeReportQuery } from 'src/app/modules/dashboard/reporting/market-linkage-initiative-report/interface/market-linkage-initiative-report-query.interface';
import { RegionFilterType } from '../../enum/region.filter-type.enum';
import { IZone } from '../../interface/project-office-zone-region-branch.interface';
import { GlobalService } from '../global/global.service';

@Injectable({
  providedIn: 'root',
})
export class MasterDataManagementService {
  allZonesByUserAndCohorts: any[] = [];

  private removeGrowthReportChildTableObs$: BehaviorSubject<any> =
    new BehaviorSubject(false);

  private removeAssetDeathReportChildTableObs$: BehaviorSubject<any> =
    new BehaviorSubject(false);
  private removeMigrationReportChildTableObs$: BehaviorSubject<any> =
    new BehaviorSubject(false);
  private removeParticipantDeathReportChildTableObs$: BehaviorSubject<any> =
    new BehaviorSubject(false);
  private removeParticipantHusbandDeathReportChildTableObs$: BehaviorSubject<any> =
    new BehaviorSubject(false);

  cohortAPI = this.globalService.apiURL_UPGParticipantSelection + '/cohort';
  programAPI = this.globalService.apiURL_UPGParticipantSelection + '/program';
  zoneAPI =
    this.globalService.apiURL_UPGParticipantSelection + '/masterdata/zone';
  regionAPI =
    this.globalService.apiURL_UPGParticipantSelection + '/masterdata/region';
  districtsAPI =
    this.globalService.apiURL_UPGParticipantSelection + '/masterdata/districts';
  subdistrictsAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/masterdata/sub-districts';
  subdistrictDetailsAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/masterdata/subDistrictDetails';
  branchAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/masterdata/branch/allBranches';
  branchByFilterAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/masterdata/branch/getAllBranchesByFilter';
  mappingZoneRegionBranchAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/project-office/mappingZoneRegionBranch';
  branchByDistrictAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/masterdata/branch/get-Branches-by-district';
  mappingBranchSubdistrictAPI =
    this.globalService.apiURL_UPGParticipantSelection + '/masterdata/branch';
  getBranchWithRmUserIdAPI =
    this.globalService.apiURL_UPGAuth + '/working-area/rm-branch';
  mappingZoneDistrictAPI =
    this.globalService.apiURL_UPGParticipantSelection + '/masterdata/zone';
  projectOfficeAPI =
    this.globalService.apiURL_UPGParticipantSelection + '/project-office';
  catchmentAreaAPI =
    this.globalService.apiURL_UPGParticipantSelection + '/catchment-area';
  geoLocationAPI =
    this.globalService.apiURL_UPGParticipantSelection + '/geo-location';
  unionAPI = this.globalService.apiURL_UPGParticipantSelection + '/union';
  aclAPI = this.globalService.apiURL_UPGAuth + '/acl';
  roleAPI = this.globalService.apiURL_UPGAuth + '/roles';
  enterpriseAPI =
    this.globalService.apiURL_UPGParticipantSelection + '/enterprise';
  groupwiseEnterpriseOfflineAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/enterprise/group-wise-enterprise/offline/all';
  groupwiseEnterpriseByGroupIdAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/enterprise/group-wise-enterprise/get-by-id';
  enterpriseWisegroupAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/enterprise/group-wise-enterprise/';
  trainingReportAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/report/training-report';
  enterpriseReportAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/report/enterprise-report';
  praReportAPI =
    this.globalService.apiURL_UPGParticipantSelection + '/report/cohorts';
  exclusionReportAPI =
    this.globalService.apiURL_UPGParticipantSelection + '/report/cohorts';
  assetTransSummaryReportAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/report/asset-transfer/transfer-summary';
  assetTransReportAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/report/asset-transfer/transfer-report';
  assetTransByGroupReportAPI =
    this.globalService.apiURL_UPGParticipantSelection +
    '/report/asset-transfer/by-groups';
  enterpripseGrowthReportAPI =
    this.globalService.apiURL_UPGReports + '/enterprise-growth';
  assetDiversificationReportAPI =
    this.globalService.apiURL_UPGReports + '/asset-diversification';
  specialReportAPI =
    this.globalService.apiURL_UPGReports + '/special-report/get';
  assetGrowthReportAPI =
    this.globalService.apiURL_UPGReports + '/asset-wise-growth';
  vsscReportAPI =
    this.globalService.apiURL_UPGReports + '/village-committee-report/get';
  vsscCommitteeListAPI =
    this.globalService.apiURL_UPGEnrollment + '/village-committees/committees';
  healthReportAPI = this.globalService.apiURL_UPGReports + '/health';
  graduationReportAPI =
    this.globalService.apiURL_UPGReports + '/graduation-report/';
  ssnpReportAPI = this.globalService.apiURL_UPGReports + '/ssnp-report';
  bkashReportAPI = this.globalService.apiURL_UPGReports + '/bkash-report/';
  workingAreaAPI = this.globalService.apiURL_UPGAuth + '/working-area';
  baselineReportAPI =
    this.globalService.apiURL_UPGReports + '/baseline-survey-report';
  poultryReportAPI = this.globalService.apiURL_UPGReports + '/poultry-report';
  enterpriseAdaptationReportAPI =
    this.globalService.apiURL_UPGReports + '/enterprise-adaptation/';

  assetScanningReportAPI =
    this.globalService.apiURL_UPGReports + '/asset-scan-report/';

  finalSelectionReportAPI =
    this.globalService.apiURL_UPGReports +
    '/participants-final-selection/cohort';

  supervisionFollowUpReportAPI =
    this.globalService.apiURL_UPGReports + '/supervision-report/';

  actionPlanReportAPI = this.globalService.apiURL_UPGAuth + '/users';

  manBoysReportAPI =
    this.globalService.apiURL_UPGReports + '/men-&-boys-report';

  selectedTagCatchmentData: any = [];

  private webAclTriggerObs$: BehaviorSubject<any> = new BehaviorSubject(false);

  constructor(
    private router: Router,
    private http: HttpClient,
    public globalService: GlobalService,
  ) {}

  // Cohort Start
  async getCohortListByProgramID(programID): Promise<Observable<any>> {
    return this.http.get(this.cohortAPI + '/' + programID).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getCohortList(): Observable<any> {
    return this.http.get(this.cohortAPI).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getCohortById(id): Observable<any> {
    return this.http.get(this.cohortAPI + '/getDetails/' + id).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  createCohort(body): Observable<any> {
    const arrayBody = [body];
    return this.http.post(this.cohortAPI, arrayBody).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  updateCohort(id, body): Observable<any> {
    return this.http.patch(this.cohortAPI + '/update/' + id, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  deleteCohort(id): Observable<any> {
    return this.http.delete(this.cohortAPI + '/' + id).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  // Cohort END

  // Programme Start

  async getProgramList(): Promise<Observable<any>> {
    return this.http.get(this.programAPI).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getProgramListTypeObservable(): Observable<any> {
    return this.http.get(this.programAPI).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getProgramByID(programID): Observable<any> {
    return this.http.get(this.programAPI + '/' + programID).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  createProgram(body): Observable<any> {
    const arrayBody = [body];
    return this.http.post(this.programAPI, arrayBody).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  updateProgram(programID, body): Observable<any> {
    delete body.id;
    return this.http.put(this.programAPI + '/' + programID, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  deleteProgram(programID): Observable<any> {
    return this.http.delete(this.programAPI + '/' + programID).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  setProgramInLocalStorage(programId: any) {
    localStorage.setItem('current_selected_program', programId);
  }

  getProgramFromLocalStorage() {
    return localStorage.getItem('current_selected_program');
  }

  setCohortInLocalStorage(cohortId) {
    localStorage.setItem('current_selected_cohort', cohortId);
  }

  getCohortFromLocalStorage() {
    return localStorage.getItem('current_selected_cohort');
  }

  // Programme END

  getDistricts(): Observable<any> {
    return this.http.get(this.districtsAPI).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  createDistrict(body: any[]): Observable<any> {
    return this.http.post(this.districtsAPI, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  createSubDistrict(body: any[]): Observable<any> {
    return this.http.post(this.subdistrictsAPI, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  getSubDistricts(filter_type: string, filter_value: string): Observable<any> {
    return this.http
      .get(
        this.subdistrictsAPI +
          '?filter_type=' +
          filter_type +
          '&filter_value=' +
          filter_value,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  getSubDistrictDetails(id): Observable<any> {
    return this.http.get(this.subdistrictDetailsAPI + '/' + id).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  async getZone(): Promise<Observable<any>> {
    return this.http.get(this.zoneAPI + '/allZone').pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  // getZoneTypeObservable(): Observable<any> {
  //   return this.http.get(this.zoneAPI + '/allZone').pipe(
  //     map((x: Response) => x),
  //     map((x: any) => x),
  //     catchError((error: Response) => {
  //       return throwError(error);
  //     })
  //   );
  // }

  getZoneById(zoneId): Observable<any> {
    return this.http.get(this.zoneAPI + '/' + zoneId).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  async createNewZone(body): Promise<Observable<any>> {
    return this.http.post(this.zoneAPI, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  editZoneInfo(id, body): Observable<any> {
    return this.http.patch(this.zoneAPI + '/' + id, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getWorkingAreasByUserAndCohorts(userID, cohortIDs): Observable<any> {
    return this.http
      .get(
        this.globalService.apiURL_UPGAuth +
          '/working-area/get-by-user?user_id=' +
          userID +
          '&cohort_ids=' +
          cohortIDs,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  getRegionByFilter(
    filter_type: RegionFilterType,
    filter_value: string,
    cohort_id?: string,
  ): Observable<any> {
    return this.http
      .get(
        cohort_id
          ? this.regionAPI +
              '?cohort_id=' +
              cohort_id +
              '&filter_type=' +
              filter_type +
              '&filter_value=' +
              filter_value
          : this.regionAPI +
              '?filter_type=' +
              filter_type +
              '&filter_value=' +
              filter_value,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  getAllRegion(): Observable<any> {
    return this.http.get(this.regionAPI + '/allRegions').pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getRegionById(regionId: string): Observable<any> {
    return this.http.get(`${this.regionAPI}/${regionId}`).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  createRegion(body): Observable<any> {
    return this.http.post(this.regionAPI, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  async getBranch(): Promise<Observable<any>> {
    return this.http.get(this.branchAPI).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getBranchTypeObservable(): Observable<any> {
    return this.http.get(this.branchAPI).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getBranchesByDistrict(districtId): Observable<any> {
    return this.http.get(this.branchByDistrictAPI + '/' + districtId).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  createBranch(body): Observable<any> {
    return this.http.post(this.mappingBranchSubdistrictAPI, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getBranchById(id): Observable<any> {
    return this.http
      .get(this.mappingBranchSubdistrictAPI + '/getDetails/' + id)
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  getBranchByFilters(
    filter_type: string,
    filter_value: string,
    cohort_id?: string,
  ): Observable<any> {
    return this.http
      .get(
        this.mappingBranchSubdistrictAPI +
          '/getAllByKeyAndFilters' +
          '?filter_type=' +
          filter_type +
          '&filter_value=' +
          filter_value +
          '&cohort_id=' +
          cohort_id,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  getBranchByRmUserId(userId: string, cohortId: string): Observable<any> {
    return this.http
      .get(
        this.getBranchWithRmUserIdAPI +
          '/cohort/' +
          cohortId +
          '/user/' +
          userId,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }
  mappingZoneRegionBranch(body: any): Observable<any> {
    return this.http.post(this.mappingZoneRegionBranchAPI, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  updateProjectOffice(id, body): Observable<any> {
    return this.http.put(this.projectOfficeAPI + '/' + id, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  deleteProjectOffice(id): Observable<any> {
    return this.http.delete(this.projectOfficeAPI + '/' + id).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  mappingZoneDistrict(zoneId, body): Observable<any> {
    return this.http
      .post(
        this.mappingZoneDistrictAPI + '/' + zoneId + '/tagDistrictsWithZone',
        body,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  mappingZoneDistrictEdit(zoneId, districtId, body): Observable<any> {
    return this.http
      .put(
        this.zoneAPI +
          '/' +
          zoneId +
          '/updateZoneDistrictMapping/' +
          districtId,
        body,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  mappingZoneDistrictDelete(zoneId, districtId): Observable<any> {
    return this.http
      .delete(
        this.zoneAPI + '/' + zoneId + '/deleteDistrictFromZone/' + districtId,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }
  async getAllProject(): Promise<Observable<any>> {
    return this.http.get(this.projectOfficeAPI).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  getProjectDetailsById(id): Observable<any> {
    return this.http.get(this.projectOfficeAPI + '/getDetail/' + id).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  mappingBranchSubdistrict(branchId, body): Observable<any> {
    return this.http
      .post(
        this.mappingBranchSubdistrictAPI +
          '/' +
          branchId +
          '/tagSubDistrictsWithBranch',
        body,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }
  mappingBranchSubdistrictEdit(branchID, subdistrictId, body): Observable<any> {
    return this.http
      .put(
        this.mappingBranchSubdistrictAPI +
          '/' +
          branchID +
          '/updateBranchSubDistrictMapping/' +
          subdistrictId,
        body,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  mappingBranchSubdistrictDelete(branchID, subdistrictId): Observable<any> {
    return this.http
      .delete(
        this.mappingBranchSubdistrictAPI +
          '/' +
          branchID +
          '/deleteSubDistrictFromBranch/' +
          subdistrictId,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  // Catchment Area
  async getCatchmentAreaList(): Promise<Observable<any>> {
    return this.http.get(this.catchmentAreaAPI).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getCatchmentAreaById(branchid, id): Observable<any> {
    return this.http
      .get(
        this.catchmentAreaAPI + '/' + branchid + '/catchmentAreaDetails/' + id,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }
  createCatchmentArea(branchId, cohortId, body): Observable<any> {
    return this.http
      .post(this.catchmentAreaAPI + '/' + branchId + '/' + cohortId, body)
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  updateCatchmentArea(id, branchId, body): Observable<any> {
    return this.http
      .patch(this.catchmentAreaAPI + '/' + branchId + '/' + id, body)
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  deleteCatchmentArea(id, branchId): Observable<any> {
    return this.http
      .delete(this.catchmentAreaAPI + '/' + branchId + '/' + id)
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  // Geo Location
  async getGeolocationList(): Promise<Observable<any>> {
    return this.http.get(this.geoLocationAPI).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  async getGeolocationListByCohortId(cohortId): Promise<Observable<any>> {
    return this.http.get(this.geoLocationAPI + '/' + cohortId).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  getGeolocationDetailsById(id): Observable<any> {
    return this.http
      .get(this.geoLocationAPI + '/geoLocationDetails/' + id)
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  createGeolocation(body): Observable<any> {
    return this.http.post(this.geoLocationAPI, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  updateGeolocation(id, body): Observable<any> {
    return this.http.put(this.geoLocationAPI + '/' + id, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  deleteGeolocation(id): Observable<any> {
    return this.http.delete(this.geoLocationAPI + '/' + id).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  // Union

  getUnionById(unionId): Observable<any> {
    return this.http.get(this.unionAPI + '/union/' + unionId).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  getAllUnion(subDistrictId): Observable<any> {
    return this.http
      .get(this.unionAPI + '?sub_district_id=' + subDistrictId)
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  createUnion(body): Observable<any> {
    return this.http.post(this.unionAPI, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  // ACL

  getAllACLByRoleId(roleId, programID, cohort?: string) {
    console.log('cohort in service', cohort);
    let params = new HttpParams();

    if (cohort) {
      params = params.set('cohort_id', cohort);
    }

    return this.http
      .get(`${this.roleAPI}/${roleId}/acl/program/${programID}`, { params })
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  getAllMenu() {
    return this.http.get(this.aclAPI + '/menu').pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getAllSubMenu(menuId) {
    return this.http.get(this.aclAPI + '/menu/' + menuId + '/submenu').pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getAllSubMenus() {
    return this.http.get(`${this.aclAPI}/menu/submenu/all`).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  createAcl(roleId, body): Observable<any> {
    return this.http.post(this.roleAPI + '/' + roleId + '/acl', body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  editAcl(aclID, roleId, body): Observable<any> {
    return this.http
      .put(this.roleAPI + '/' + roleId + '/acl/' + aclID, body)
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  deleteAcl(aclID, roleId): Observable<any> {
    return this.http.delete(this.roleAPI + '/' + roleId + '/acl/' + aclID).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  // setTagCatchMentAreaModel(data, previousUnionId) {
  //   var indexCurrent = this.selectedTagCatchmentData.findIndex(
  //     (s) =>
  //       s.sub_district_id == data.sub_district_id && s.union_id == data.union_id
  //   );
  //   if (indexCurrent == -1) {
  //     this.selectedTagCatchmentData.push(data);
  //   }

  //   var indexPre = this.selectedTagCatchmentData.findIndex(
  //     (s) => s.union_id == previousUnionId
  //   );
  //   if (indexPre > -1) {
  //     this.selectedTagCatchmentData.splice(indexPre, 1);
  //   }
  // }

  setTagCatchMentAreaModel(data, actionType) {
    const indexCurrent = this.selectedTagCatchmentData.findIndex(
      (s) => s.district_id == data.district_id,
    );
    // If district already present then delete / splice it.
    if (indexCurrent > -1) {
      this.selectedTagCatchmentData.splice(indexCurrent, 1);
    }

    if (actionType == 'add') {
      // Then Push
      this.selectedTagCatchmentData.push(data);
    }
  }
  getTagCatchMentAreaModel() {
    return this.selectedTagCatchmentData;
  }

  // Enterprise
  getEnterpriseCatagory(cohortID) {
    return this.http
      .get(
        this.globalService.apiURL_UPGParticipantSelection +
          '/' +
          cohortID +
          '/enterprise-category',
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  getEnterpriseByFilterType(cohortID, filter_type, filter_value) {
    let link;
    if (filter_type && filter_value) {
      link =
        this.enterpriseAPI +
        '/' +
        cohortID +
        '?' +
        filter_type +
        '=' +
        filter_value;
    } else {
      link = this.enterpriseAPI + '/' + cohortID;
    }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getGroupWiseEnterpriseOfflineAll() {
    return this.http.get(this.groupwiseEnterpriseOfflineAPI).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getGroupWiseEnterpriseByGroupId(id) {
    return this.http.get(this.groupwiseEnterpriseByGroupIdAPI + '/' + id).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  getEnterpriseWiseGroupsId(cohort_id, enterprise_id) {
    return this.http
      .get(
        this.enterpriseWisegroupAPI +
          '/cohort/' +
          cohort_id +
          '/enterprises/' +
          enterprise_id +
          '/groups',
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }
  getGroupByCohort(cohortID) {
    return this.http
      .get(
        this.globalService.apiURL_UPGParticipantSelection +
          '/' +
          cohortID +
          '/group',
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  getEnterpriseByCohort(cohortId: string, groupIds?: string[]) {
    return this.http
      .get(
        `${this.enterpriseAPI}/cohort/${cohortId}${groupIds?.length ? `?group_ids=${groupIds}` : ''}`,
      )
      .pipe(
        map((x: Response) => x),
        map((x: any) => x),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  getTrainingReport(body): Observable<any> {
    return this.http.post(this.trainingReportAPI, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  getEnterpriseReport(body): Observable<any> {
    return this.http.post(this.enterpriseReportAPI, body).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getPRAStatsReport(
    cohortID,
    filter_type,
    filter_value,
    fromDate,
    toDate,
    report_type?,
  ): Observable<any> {
    let link;
    link = this.praReportAPI + '/' + cohortID + '/stats?';

    if (filter_type && filter_value) {
      link =
        link + '&filter_type=' + filter_type + '&filter_value=' + filter_value;
    }
    if (fromDate && toDate) {
      link = link + '&from=' + fromDate + '&to=' + toDate;
    }
    if (report_type != 'default') {
      link = link + '&report_type=' + report_type;
    }
    // else {
    //   link = this.praReportAPI + '/' + cohortID + '/stats';
    // }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  getExclusionReport(
    cohortID,
    filter_type,
    filter_value,
    groupsId,
    fromDate,
    toDate,
  ): Observable<any> {
    let link = this.exclusionReportAPI + '/' + cohortID + '/exclution-stats?';
    if (filter_type && filter_value) {
      link =
        link + '&filter_type=' + filter_type + '&filter_value=' + filter_value;
    }
    if (groupsId) {
      link = link + '&group_ids=' + groupsId;
    }
    if (fromDate && toDate) {
      link = link + '&from=' + fromDate + '&to=' + toDate;
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  getAssetTransSummaryReport(
    cohortID,
    filter_type,
    filter_value,
    fromDate,
    toDate,
  ): Observable<any> {
    let link;
    link = this.assetTransSummaryReportAPI + '?cohort_id=' + cohortID;

    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }
    if (fromDate && toDate) {
      link = link + '&start_date=' + fromDate + '&end_date=' + toDate;
    }

    // this.assetTransSummaryReportAPI +
    // '?cohort_id=' +
    // cohortID +
    // '&area_filter_type=' +
    // filter_type +
    // '&area_filter_value=' +
    // filter_value;
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  getAssetTransReport(
    cohortID,
    filter_type,
    filter_value,
    fromDate,
    toDate,
  ): Observable<any> {
    let link;
    link = this.assetTransReportAPI + '?cohort_id=' + cohortID;
    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }
    if (fromDate && toDate) {
      link = link + '&start_date=' + fromDate + '&end_date=' + toDate;
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
  getAssetTransReportByGroup(
    cohortID,
    groupIds,
    enterpriseIds,
    filter_type,
    filter_value,
    fromDate,
    toDate,
  ): Observable<any> {
    let link;

    link =
      this.assetTransByGroupReportAPI +
      '?cohort_id=' +
      cohortID +
      '&group_ids=' +
      groupIds;

    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }
    if (enterpriseIds) {
      link = link + '&enterprise_ids=' + enterpriseIds;
    }
    if (fromDate && toDate) {
      link = link + '&start_date=' + fromDate + '&end_date=' + toDate;
    }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getEnterpriseGrowthByCohortID(
    cohortID,
    enterpriseId,
    filter_type,
    filter_value,
    group_ids,
    fromDate,
    toDate,
    with_po = false,
  ): Observable<any> {
    let link;

    link =
      this.enterpripseGrowthReportAPI +
      '/cohort/' +
      cohortID +
      '/enterprise/' +
      enterpriseId;

    if (filter_type && filter_value) {
      link =
        link + '?filter_type=' + filter_type + '&filter_value=' + filter_value;

      if (group_ids) {
        link = link + '&groups=' + group_ids;
      }
      if (fromDate) {
        link = link + '&from_date=' + fromDate;
      }
      if (toDate) {
        link = link + '&to_date=' + toDate;
      }
      link = link + '&with_po=' + with_po;
    } else {
      if (group_ids) {
        link = link + '?groups=' + group_ids;
        if (fromDate) {
          link = link + '&from_date=' + fromDate;
        }
        if (toDate) {
          link = link + '&to_date=' + toDate;
        }
        link = link + '&with_po=' + with_po;
      } else {
        if (fromDate && toDate) {
          link = link + '?from_date=' + fromDate + '&to_date=' + toDate;
          link = link + '&with_po=' + with_po;
        } else {
          if (fromDate) {
            link = link + '?from_date=' + fromDate;
          }
          if (toDate) {
            link = link + '?to_date=' + toDate;
          }
          link = link + '&with_po=' + with_po;
        }
      }
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getAssetDiversificationByCohortID(
    cohortID,
    filter_type,
    filter_value,
    fromDate,
    toDate,
    group_ids,
    enterprises,
    asset_id,
  ): Observable<any> {
    let link;

    link = this.assetDiversificationReportAPI + '/cohort/' + cohortID + '?';

    // if (filter_type && filter_value) {
    //   link =
    //     link + '&filter_type=' + filter_type + '&filter_value=' + filter_value;
    //     if (group_ids) {
    //       link = link + '&groups=' + group_ids;
    //     }
    //     if (enterprises) {
    //       link = link + '&enterprises=' + enterprises;
    //     }
    //     if (asset_id) {
    //       link = link + '&asset_id=' + asset_id;
    //     }
    //   if (fromDate) {
    //     link = link + '&from_date=' + fromDate;
    //   }
    //   if (toDate) {
    //     link = link + '&to_date=' + toDate;
    //   }
    // } else {
    //   if (group_ids) {
    //     link = link + '?groups=' + group_ids;
    //     if (fromDate) {
    //       link = link + '&from_date=' + fromDate;
    //     }
    //     if (toDate) {
    //       link = link + '&to_date=' + toDate;
    //     }
    //   } else {
    //     if (fromDate && toDate) {
    //       link = link + '?from_date=' + fromDate + '&to_date=' + toDate;
    //     } else {
    //       if (fromDate) {
    //         link = link + '?from_date=' + fromDate;
    //       }
    //       if (toDate) {
    //         link = link + '?to_date=' + toDate;
    //       }
    //     }
    //   }
    // }

    if (filter_type && filter_value) {
      link =
        link + '&filter_type=' + filter_type + '&filter_value=' + filter_value;
    }
    if (group_ids) {
      link = link + '&groups=' + group_ids;
    }
    if (enterprises) {
      link = link + '&enterprises=' + enterprises;
    }
    if (asset_id) {
      link = link + '&asset_id=' + asset_id;
    }
    if (fromDate) {
      link = link + '&from_date=' + fromDate;
    }
    if (toDate) {
      link = link + '&to_date=' + toDate;
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getProjectOfficeByCohortId(cohortId): Observable<any> {
    return this.http.get(this.projectOfficeAPI + '/' + cohortId).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getProjectOfficeZoneRegionListsByCohortId(cohortId): Observable<any> {
    return this.http.get(this.projectOfficeAPI + '/' + cohortId).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      mergeMap((x: any) => {
        const arr = x.resultset;
        const zoneMap: Map<string, IZone> = new Map();

        arr.forEach((data) => {
          // Check if zone exists
          if (!zoneMap.has(data.zone_id)) {
            zoneMap.set(data.zone_id, {
              zone_id: data.zone_id,
              zone_name: data.zone_name,
              regions: new Map(),
            });
          }
          const zone = zoneMap.get(data.zone_id);
          // Check if region exists
          if (!zone.regions.has(data.region_id)) {
            zone.regions.set(data.region_id, {
              region_id: data.region_id,
              region_name: data.region_name,
              branches: [],
            });
          }
          const region = zone.regions.get(data.region_id);
          // Add branch
          region.branches.push({
            branch_id: data.branch_id,
            branch_name: data.branch_name,
            is_active: data.is_active,
          });
          zone.regions.delete(data.region_id);
          zone.regions.set(data.region_id, region);
          zoneMap.delete(data.zone_id);
          zoneMap.set(data.zone_id, zone);
        });
        return of(
          [...zoneMap.values()].sort(
            this.globalService.dynamicSortCaseInsensitive('zone_name'),
          ),
        );
      }),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getRemoveGrowthReportChildTableObs(): Observable<any> {
    return this.removeGrowthReportChildTableObs$.asObservable();
  }

  setRemoveGrowthReportChildTableObs(data) {
    this.removeGrowthReportChildTableObs$.next(data);
  }

  getSpecialReport(
    cohortID,
    filter_type,
    filter_value,
    fromDate,
    toDate,
    groupIds,
  ): Observable<any> {
    let link;
    link = this.specialReportAPI + '?cohort_id=' + cohortID;
    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }
    if (fromDate) {
      link = link + '&from_date=' + fromDate;
    }
    if (toDate) {
      link = link + '&to_date=' + toDate;
    }
    if (groupIds) {
      link = link + '&group_ids=' + groupIds;
    }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getAssetGrowthByCohortID(
    cohortID,
    assetId,
    filter_type,
    filter_value,
    group_ids,
    fromDate,
    toDate,
    with_po = false,
  ): Observable<any> {
    let link;

    link =
      this.assetGrowthReportAPI + '/cohort/' + cohortID + '/asset/' + assetId;

    // if (filter_type && filter_value) {
    //   link =
    //     link + '?filter_type=' + filter_type + '&filter_value=' + filter_value;

    //   if (group_ids) {
    //     link = link + '&groups=' + group_ids;
    //   }
    //   if (fromDate) {
    //     link = link + '&from_date=' + fromDate;
    //   }
    //   if (toDate) {
    //     link = link + '&to_date=' + toDate;
    //   }
    //   link = link + '&with_po=' + with_po;
    // } else {
    //   if (group_ids) {
    //     link = link + '?groups=' + group_ids;
    //     if (fromDate) {
    //       link = link + '&from_date=' + fromDate;
    //     }
    //     if (toDate) {
    //       link = link + '&to_date=' + toDate;
    //     }
    //     link = link + '&with_po=' + with_po;
    //   } else {
    //     if (fromDate && toDate) {
    //       link = link + '?from_date=' + fromDate + '&to_date=' + toDate;
    //       link = link + '&with_po=' + with_po;
    //     } else {
    //       if (fromDate) {
    //         link = link + '?from_date=' + fromDate;
    //       }
    //       if (toDate) {
    //         link = link + '?to_date=' + toDate;
    //       }
    //       link = link + '&with_po=' + with_po;
    //     }
    //   }
    // }

    let params = new HttpParams();
    if (filter_type && filter_value) {
      params = params.set('filter_type', filter_type);
      params = params.set('filter_value', filter_value);
    }
    if (group_ids) {
      params = params.set('groups', group_ids);
    }
    if (fromDate) {
      params = params.set('from_date', fromDate);
    }
    if (toDate) {
      params = params.set('to_date', toDate);
    }
    params = params.set('with_po', String(with_po));

    return this.http.get(link, { params }).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getVsscReport(
    cohortID,
    filter_type,
    filter_value,
    fromDate,
    toDate,
    activity_type?: string,
    committee_ids?: string,
  ): Observable<any> {
    let link;
    link = this.vsscReportAPI + '?cohort_id=' + cohortID;
    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }
    if (fromDate && toDate) {
      link = link + '&from_date=' + fromDate + '&to_date=' + toDate;
    }
    if (activity_type) {
      link = link + '&activity_type=' + activity_type;
    }
    if (committee_ids) {
      link = link + '&committee_ids=' + committee_ids;
    }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getVsscCommitteeList(
    cohortID: string,
    filter_type?: string,
    filter_value?: string,
  ): Observable<any> {
    let link = this.vsscCommitteeListAPI + '?cohort_id=' + cohortID;
    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getHealthReport(
    cohortID: string,
    filter_type: string,
    filter_value: string[],
    fromDate,
    toDate,
  ): Observable<any> {
    let link;
    link = this.healthReportAPI + '/cohort/' + cohortID + '/?';

    if (filter_type && filter_value) {
      link =
        link + '&filter_type=' + filter_type + '&filter_value=' + filter_value;
    }
    if (fromDate) {
      link = link + '&from_date=' + fromDate;
    }
    if (toDate) {
      link = link + '&to_date=' + toDate;
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getHealthReportPart2(
    cohortID: string,
    filter_type: string,
    filter_value: string[],
    fromDate,
    toDate,
  ): Observable<any> {
    let link;
    link = this.healthReportAPI + '/cohort/' + cohortID + '/expenditure/?';

    if (filter_type && filter_value) {
      link =
        link + '&filter_type=' + filter_type + '&filter_value=' + filter_value;
    }
    if (fromDate) {
      link = link + '&from_date=' + fromDate;
    }
    if (toDate) {
      link = link + '&to_date=' + toDate;
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getGraduationReport(
    cohortID,
    groupIds,
    filter_type,
    filter_value,
    fromDate,
    toDate,
  ): Observable<any> {
    let link;
    link = this.graduationReportAPI + 'get?cohort_id=' + cohortID;
    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }
    if (fromDate && toDate) {
      link = link + '&from_date=' + fromDate + '&to_date=' + toDate;
    }
    if (groupIds) {
      link = link + '&group_ids=' + groupIds;
    }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getGraduationReportGroupOne(
    cohortID,
    groupID,
    filter_type,
    filter_value,
    fromDate,
    toDate,
  ): Observable<any> {
    let link =
      this.graduationReportAPI +
      'for-group-one?cohort_id=' +
      cohortID +
      '&group_id=' +
      groupID;

    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }

    if (fromDate && toDate) {
      link = link + '&from_date=' + fromDate + '&to_date=' + toDate;
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getSSNPReport(
    cohortID,
    cohortName,
    groupIds,
    filter_type,
    filter_value,
    fromDate,
    toDate,
    refId?,
  ): Observable<any> {
    let link;
    link =
      this.ssnpReportAPI +
      '?cohort_id=' +
      cohortID +
      '&cohort_name=' +
      cohortName;

    if (filter_type && filter_value) {
      link =
        link + '&filter_type=' + filter_type + '&filter_values=' + filter_value;
    }
    if (fromDate && toDate) {
      link = link + '&from_date=' + fromDate + '&to_date=' + toDate;
    }
    if (groupIds) {
      link = link + '&group_ids=' + groupIds;
    }

    if (refId) {
      link = link + '&ref_id=' + refId;
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getBKashReport(
    cohortID,
    groupIDs,
    filter_type,
    filter_value,
    fromDate,
    toDate,
    selection_status,
    partName,
  ): Observable<any> {
    let link;
    link = this.bkashReportAPI + 'get?cohort_id=' + cohortID;
    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }
    if (fromDate && toDate) {
      link = link + '&from_date=' + fromDate + '&to_date=' + toDate;
    }
    if (groupIDs) {
      link = link + '&group_ids=' + groupIDs;
    }
    if (selection_status) {
      link = link + '&selection_status=' + selection_status;
    }
    if (partName) {
      link = link + '&part_no=' + partName;
    }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getwebACLTriggerObs(): Observable<any> {
    return this.webAclTriggerObs$.asObservable();
  }
  setwebACLTriggerObs(data) {
    this.webAclTriggerObs$.next(data);
  }

  getSurveyReport(
    cohortId: string,
    areaFilterType: string,
    areaFilterValues: string[],
  ): Observable<any> {
    let link = `${this.globalService.apiURL_UPGReports}/survey-report/get?cohort_id=${cohortId}`;
    if (areaFilterType && areaFilterValues?.length) {
      link += `&area_filter_type=${areaFilterType}&area_filter_values=${areaFilterValues}`;
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getSurveyReportByExcel(
    cohortId: string,
    areaFilterType: string,
    areaFilterValues: string[],
  ): Observable<HttpResponse<Blob>> {
    let link = `${this.globalService.apiURL_UPGReports}/survey-report/export-excel?cohort_id=${cohortId}`;
    if (areaFilterType && areaFilterValues?.length) {
      link += `&area_filter_type=${areaFilterType}&area_filter_values=${areaFilterValues}`;
    }
    return this.http.get(link, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  getBaseLineReport(
    cohortID,
    groupIds,
    filter_type,
    filter_value,
  ): Observable<any> {
    let link;
    link = this.baselineReportAPI + '?cohort_id=' + cohortID;
    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }
    // if (fromDate && toDate) {
    //   link = link
    //   + '&from_date=' + fromDate
    //   + '&to_date=' + toDate ;
    // }
    if (groupIds) {
      link = link + '&group_ids=' + groupIds;
    }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getPoultryReport(
    cohortID,
    assetId,
    filter_type,
    filter_value,
    group_ids,
  ): Observable<any> {
    let link;

    link =
      this.poultryReportAPI + '/cohort/' + cohortID + '?asset_type=' + assetId;

    if (filter_type && filter_value) {
      link =
        link + '&filter_type=' + filter_type + '&filter_value=' + filter_value;

      if (group_ids) {
        link = link + '&groups=' + group_ids;
      }
    } else {
      if (group_ids) {
        link = link + '&groups=' + group_ids;
      }
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getMarketLinkageInitiativeReport(
    model: IMarketLinkageInitiativeReportQuery,
  ): Observable<any> {
    let link = `${this.globalService.apiURL_UPGReports}/market-linkage-report?cohort_id=${model.cohort_id}`;

    if (model.filter_type && model.filter_value) {
      link += `&area_filter_type=${model.filter_type}&area_filter_values=${model.filter_value}`;
    }

    if (model.from_date) {
      link += `&from_date=${model.from_date}`;
    }

    if (model.to_date) {
      link += `&to_date=${model.to_date}`;
    }

    if (model.group_ids?.length) {
      link += `&group_ids=${model.group_ids.toString()}`;
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getRemove_AssetDeathReport_ChildTableObs(): Observable<any> {
    return this.removeAssetDeathReportChildTableObs$.asObservable();
  }
  setRemove_AssetDeathReport_ChildTableObs(data) {
    this.removeAssetDeathReportChildTableObs$.next(data);
  }

  getRemove_MigrationReport_ChildTableObs(): Observable<any> {
    return this.removeMigrationReportChildTableObs$.asObservable();
  }
  setRemove_MigrationReport_ChildTableObs(data) {
    this.removeMigrationReportChildTableObs$.next(data);
  }

  getRemove_ParticipantDeathReport_ChildTableObs(): Observable<any> {
    return this.removeParticipantDeathReportChildTableObs$.asObservable();
  }
  setRemove_participantDeathReport_ChildTableObs(data) {
    this.removeParticipantDeathReportChildTableObs$.next(data);
  }

  getRemove_ParticipantHusbandDeathReport_ChildTableObs(): Observable<any> {
    return this.removeParticipantHusbandDeathReportChildTableObs$.asObservable();
  }
  setRemove_ParticipantHusbandDeathReport_ChildTableObs(data) {
    this.removeParticipantHusbandDeathReportChildTableObs$.next(data);
  }

  getMigrationReport(
    cohortID,
    cohortName,
    groupIds,
    filter_type,
    filter_value,
    fromDate,
    toDate,
  ): Observable<any> {
    let link;
    link =
      this.globalService.apiURL_UPGReports +
      '/migration-report' +
      '?cohort_id=' +
      cohortID;

    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }
    if (fromDate && toDate) {
      link = link + '&from_date=' + fromDate + '&to_date=' + toDate;
    }
    if (groupIds) {
      link = link + '&group_ids=' + groupIds;
    }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getAssetDeathReport(
    cohortID,
    cohortName,
    groupIds,
    filter_type,
    filter_value,
    fromDate,
    toDate,
  ): Observable<any> {
    let link;
    link =
      this.globalService.apiURL_UPGReports +
      '/asset-death-report' +
      '?cohort_id=' +
      cohortID;

    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }
    if (fromDate && toDate) {
      link = link + '&from_date=' + fromDate + '&to_date=' + toDate;
    }
    if (groupIds) {
      link = link + '&group_ids=' + groupIds;
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getParticipantsDeathReport(
    cohortID,
    cohortName,
    groupIds,
    filter_type,
    filter_value,
    fromDate,
    toDate,
  ): Observable<any> {
    let link;
    link =
      this.globalService.apiURL_UPGReports +
      '/participants-death/cohort/' +
      cohortID;

    if (filter_type && filter_value) {
      link =
        link +
        '?filter_type=' +
        filter_type.toUpperCase() +
        '&filter_value=' +
        filter_value;
      if (fromDate && toDate) {
        link = link + '&from_date=' + fromDate + '&to_date=' + toDate;
      }
      if (groupIds) {
        link = link + '&groups=' + groupIds;
      }
    } else if (fromDate && toDate) {
      link = link + '?from_date=' + fromDate + '&to_date=' + toDate;
      if (groupIds) {
        link = link + '&groups=' + groupIds;
      }
    } else if (groupIds) {
      link = link + '?groups=' + groupIds;
    }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getParticipantsHusbandDeathReport(
    cohortID,
    cohortName,
    groupIds,
    filter_type,
    filter_value,
    fromDate,
    toDate,
  ): Observable<any> {
    let link;
    link =
      this.globalService.apiURL_UPGReports +
      '/participants-husband-death/cohort/' +
      cohortID;

    if (filter_type && filter_value) {
      link =
        link +
        '?filter_type=' +
        filter_type.toUpperCase() +
        '&filter_value=' +
        filter_value;
      if (fromDate && toDate) {
        link = link + '&from_date=' + fromDate + '&to_date=' + toDate;
      }
      if (groupIds) {
        link = link + '&groups=' + groupIds;
      }
    } else if (fromDate && toDate) {
      link = link + '?from_date=' + fromDate + '&to_date=' + toDate;
      if (groupIds) {
        link = link + '&groups=' + groupIds;
      }
    } else if (groupIds) {
      link = link + '?groups=' + groupIds;
    }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getBranchListByCohort(cohortID): Observable<any> {
    let link;
    link =
      this.globalService.apiURL_UPGAuth +
      '/masterdata/branch/cohort/' +
      cohortID;

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getEnterpriseAdaptationByCohortID(
    cohortID,
    filter_type,
    filter_value,
    group_ids,
    participant_state,
  ): Observable<any> {
    let link;

    link = this.enterpriseAdaptationReportAPI + 'cohort/' + cohortID;

    if (filter_type && filter_value) {
      link =
        link + '?filter_type=' + filter_type + '&filter_values=' + filter_value;

      if (group_ids) {
        link = link + '&groups=' + group_ids;
      }
      if (participant_state) {
        link = link + '&participant_state=' + participant_state;
      }
    } else {
      if (group_ids) {
        link = link + '?groups=' + group_ids;
        if (participant_state) {
          link = link + '&participant_state=' + participant_state;
        }
      } else if (participant_state) {
        link = link + '?participant_state=' + participant_state;
      }
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getAssetScanningReportByCohortID(
    cohortID,
    filter_type,
    filter_value,
    group_ids,
    fromDate,
    toDate,
  ): Observable<any> {
    let link;

    link = this.assetScanningReportAPI + 'cohort/' + cohortID;

    if (filter_type && filter_value) {
      link =
        link + '?filter_type=' + filter_type + '&filter_value=' + filter_value;

      if (group_ids) {
        link = link + '&groups=' + group_ids;
      }
      if (fromDate) {
        link = link + '&from_date=' + fromDate;
      }
      if (toDate) {
        link = link + '&to_date=' + toDate;
      }
    } else {
      if (group_ids) {
        link = link + '?groups=' + group_ids;
        if (fromDate) {
          link = link + '&from_date=' + fromDate;
        }
        if (toDate) {
          link = link + '&to_date=' + toDate;
        }
      } else {
        if (fromDate && toDate) {
          link = link + '?from_date=' + fromDate + '&to_date=' + toDate;
        } else {
          if (fromDate) {
            link = link + '?from_date=' + fromDate;
          }
          if (toDate) {
            link = link + '?to_date=' + toDate;
          }
        }
      }
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getFinalSelectionReport(
    cohortID,
    filter_type,
    filter_value,
    group_ids,
    fromDate,
    toDate,
  ): Observable<any> {
    let link = this.finalSelectionReportAPI + '/' + cohortID;

    if (filter_type && filter_value) {
      link =
        link + '?filter_type=' + filter_type + '&filter_value=' + filter_value;

      if (group_ids) {
        link = link + '&groups=' + group_ids;
      }
      if (fromDate) {
        link = link + '&from_date=' + fromDate;
      }
      if (toDate) {
        link = link + '&to_date=' + toDate;
      }
    } else {
      if (group_ids) {
        link = link + '?groups=' + group_ids;
        if (fromDate) {
          link = link + '&from_date=' + fromDate;
        }
        if (toDate) {
          link = link + '&to_date=' + toDate;
        }
      } else {
        if (fromDate && toDate) {
          link = link + '?from_date=' + fromDate + '&to_date=' + toDate;
        } else {
          if (fromDate) {
            link = link + '?from_date=' + fromDate;
          }
          if (toDate) {
            link = link + '?to_date=' + toDate;
          }
        }
      }
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  public getUviSelectionReport(
    cohortId: string,
    minWeightedScore: number,
    maxWeightedScore: number,
    filterType?: string,
    filterValues?: string[],
  ) {
    const url = `${
      this.globalService.apiURL_UPGReports
    }/uvi-report?cohort_id=${cohortId}&max_weighted_score=${maxWeightedScore}&min_weighted_score=${minWeightedScore} ${
      filterType && filterValues
        ? `&area_filter_type=${filterType}&area_filter_values=${filterValues}`
        : ''
    }`;

    return this.http.get(url).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  public getNeedAssesmentSpCmReport(
    cohortId: string,
    filterType?: string,
    filterValues?: string[],
    groupIds?: string[],
    enterpriseIds?: string[],
  ) {
    const url = `${
      this.globalService.apiURL_UPGReports
    }/esi-report/need-assesment-sp-cm?cohort_id=${cohortId}${
      filterType && filterValues
        ? `&area_filter_type=${filterType}&area_filter_values=${filterValues}`
        : ''
    }${groupIds?.length ? `&group_ids=${groupIds}` : ''}${
      enterpriseIds?.length ? `&enterprise_ids=${enterpriseIds}` : ''
    }`;

    return this.http.get(url).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getActionPlanReport(
    cohortID: string,
    filter_type: string,
    filter_value: string,
  ): Observable<any> {
    // let filter_value: string = null;

    // filter_values.length > 0
    //   ? (filter_value = filter_values.join(','))
    //   : (filter_value = '');

    let link =
      this.actionPlanReportAPI +
      `/filter/get-by-area?cohort_id=${cohortID}&area_filter_type=${filter_type}&area_filter_value=${filter_value}`;
    // if (filter_type && filter_value) {
    //   link =
    //     link +
    //     '&area_filter_type=' +
    //     filter_type +
    //     '&area_filter_values=' +
    //     filter_value;
    // }
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getSupervisionUserFollowUpReport(
    cohortID: string,
    userId: string,
    dates: string,
  ): Observable<any> {
    let link =
      this.supervisionFollowUpReportAPI +
      `user-follow-up?cohort_id=${cohortID}&user_id=${userId}&dates=${dates}`;
    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  async getAllDataForHaadOfficeUsersReport(
    cohortId: string,
    filterType?: string,
    filterValues?: string,
    date?: string,
  ) {
    const url = `${
      this.globalService.apiURL_UPGReports
    }/supervision-report/participant-follow-up?cohort_id=${cohortId}${
      filterType && filterValues
        ? `&area_filter_type=${filterType}&area_filter_values=${filterValues}`
        : ''
    }${date ? `&date=${date}` : ''}`;

    return this.http.get(url).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  getManBoysReport(
    cohortID,
    groupIds,
    filter_type,
    filter_value,
    fromDate,
    toDate,
  ): Observable<any> {
    let link;
    link = this.manBoysReportAPI + '?cohort_id=' + cohortID;
    if (groupIds) {
      link = link + '&group_ids=' + groupIds;
    }
    if (filter_type && filter_value) {
      link =
        link +
        '&area_filter_type=' +
        filter_type +
        '&area_filter_values=' +
        filter_value;
    }
    // if (fromDate && toDate) {
    //   link = link + '&from_date=' + fromDate + '&to_date=' + toDate;
    // }
    if (fromDate) {
      link = link + '&from_date=' + fromDate;
    }
    if (toDate) {
      link = link + '&to_date=' + toDate;
    }

    return this.http.get(link).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  public getNeedAssesmentHealthCareReport(
    cohortId: string,
    filterType?: string,
    filterValues?: string[],
    groupIds?: string[],
    enterpriseIds?: string[],
  ) {
    const url = `${
      this.globalService.apiURL_UPGReports
    }/esi-report/need-assesment-health-care?cohort_id=${cohortId}${
      filterType && filterValues
        ? `&area_filter_type=${filterType}&area_filter_values=${filterValues}`
        : ''
    }${groupIds?.length ? `&group_ids=${groupIds}` : ''}${
      enterpriseIds?.length ? `&enterprise_ids=${enterpriseIds}` : ''
    }`;
    return this.http.get(url).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }

  public getMfTransferReport(
    cohortId: string,
    filterType?: string,
    filterValues?: string[],
    groupIds?: string[],
    is_mf_transfered?: boolean | string,
    has_availed_dabi_loan?: boolean | string,
  ) {
    const url = `${
      this.globalService.apiURL_UPGReports
    }/mf-transfer-report?cohort_id=${cohortId}${
      filterType && filterValues?.length
        ? `&area_filter_type=${filterType}&area_filter_values=${filterValues}`
        : ''
    }${groupIds?.length ? `&group_ids=${groupIds}` : ''}${
      is_mf_transfered !== null && is_mf_transfered !== undefined && is_mf_transfered !== ''
        ? `&is_mf_transfered=${encodeURIComponent(String(is_mf_transfered))}`
        : ''
    }${
      has_availed_dabi_loan !== null && has_availed_dabi_loan !== undefined && has_availed_dabi_loan !== ''
        ? `&has_availed_dabi_loan=${encodeURIComponent(String(has_availed_dabi_loan))}`
        : ''
    }`;
    return this.http.get(url).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      }),
    );
  }
}
